import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "h-full w-full",
  viewBox: "0 0 72 72"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "36",
      cy: "36",
      r: "36",
      fill: "#0076bb",
      "data-name": "Ellipse 70"
    }, null, -1)
  ])))
}
export default { render: render }